import { render, staticRenderFns } from "./global-pick.vue?vue&type=template&id=09fe5e14&scoped=true&"
import script from "./global-pick.vue?vue&type=script&lang=js&"
export * from "./global-pick.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09fe5e14",
  null
  
)

export default component.exports